module.exports = __webpack_public_path__ + "img/撤回账单.63a4131e.svg";